import React from "react";
import Skeleton from "react-loading-skeleton";

const WidgetSkeloton = () => {
  return (
    <div className="col-lg-4 col-xl-3 col-md-4 col-6 mb-2">
      <div className="device bg-white w-100 p-2">
        <div className="d-flex align-items-center justify-content-around">
          <div>
            <Skeleton circle={true} width={52} height={52} />
          </div>
          <div className="w-50">
            <div className="d-flex justify-content-between fn">
              <Skeleton width={60} height={15} />
            </div>
            <div className="d-flex justify-content-between activeDeviceStatus fn10">
              <Skeleton width={40} height={10} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { WidgetSkeloton };
